import React from 'react';

const Unsupported = () =>
  <div>
    <h1 className="gap-bottom-large">Unsupported Browser</h1>
    <p>Your browser does not support this game :(</p>
  </div>;

export default Unsupported;
